import type MenuItem from '../../Models/MenuItem';
import React, { useState } from 'react';
import Styles from '../Menu/Menu.module.scss';
import MenuUIItem from '../MenuUIItem/MenuUIItem';
import { useTranslation } from 'react-i18next';
import { normalize } from '@/Utility/StringFunctions';

function FullMenu({ title, menuItems, addToFavorites, filter, defaultHidden }: Readonly<{
    title: string; menuItems: MenuItem[]; addToFavorites: Function; filter: string; defaultHidden?: boolean;
}>): React.ReactElement {
    const { t } = useTranslation();
    const [hidden, setHidden] = useState<boolean>(defaultHidden ?? false);

    const dragOver = (event: any): void => {
        event.stopPropagation();
        event.preventDefault();
    };
    const toggle = (): void => {
        setHidden(!hidden);
    };

    const filterItems = (): MenuItem[] => {
        if (filter === '') {
            return menuItems;
        }

        const copy = JSON.parse(JSON.stringify(menuItems)) as MenuItem[]; // deep copy before filter
        const checkID = (id: string): boolean => normalize(t(id)).includes(normalize(filter));
        const items = copy.filter((x) => (x.MenuItemSub == null || x.MenuItemSub.length === 0) ? checkID(x.ID) : x.MenuItemSub.some((y) => checkID(y.ID)));
        items.forEach((item) => {
            if (!item.MenuItemSub || item.MenuItemSub.length === 0) {
                return;
            }
            item.MenuItemSub = item.MenuItemSub.filter((x) => checkID(x.ID));
        });
        return items;
    };

    return (
        <ul className={Styles.leftNav}>
            {/* Title */}
            <button
                className={Styles.navHeader}
                onDragOver={dragOver}
                onClick={toggle}
            >
                <div className={Styles.menuHeader}>{title}</div>
                <span className="material-symbols-outlined">{ hidden ? 'keyboard_arrow_right' : 'keyboard_arrow_down'}</span>
            </button>

            {/* Items */}
            <div hidden={hidden}>
                <ul>
                    { filterItems().map((item) => <MenuUIItem key={item.ID} item={item} addToFavorites={addToFavorites} alwaysOpen={filter !== ''} />) }
                </ul>
            </div>
        </ul>
    );
}

export default FullMenu;
